// Tipos e catálogos do Diário de Obra, compartilhados entre backend e front-end.

export type TempoCondicao = "SOL" | "NUBLADO" | "CHUVA" | "MUITA CHUVA";
export const TEMPO_CONDICOES: TempoCondicao[] = ["SOL", "NUBLADO", "CHUVA", "MUITA CHUVA"];

export type TipoItem = "equipamento" | "mao_obra" | "equipe_fiscalizacao";

export interface DiarioItem {
  id?: number;
  tipo: TipoItem;
  nome: string;
  quantidade: number;
  ordem: number;
}

export interface DiarioFoto {
  id?: number;
  caminho: string;
  legenda: string;
  ordem: number;
  url?: string; // URL assinada temporária para exibição
}

export interface Diario {
  id: number;
  numero: string;
  data: string; // YYYY-MM-DD
  folha: string;
  obra: string;
  ordem_servico: string;
  empresa_contratada: string;
  numero_contrato: string;
  data_inicio: string | null;
  data_final: string | null;
  prazo_dias: string;
  dias_corridos: string;
  servicos_executados: string;
  observacoes_fiscalizacao: string;
  observacao_contratada: string;
  observacao_fiscalizacao_rodape: string;
  tempo_manha: TempoCondicao | null;
  tempo_tarde: TempoCondicao | null;
  assinatura_responsavel_nome: string;
  assinatura_responsavel_img: string | null;
  assinatura_fiscal_nome: string;
  assinatura_fiscal_img: string | null;
  criado_por: number;
  fiscal_id: number | null;
  criado_em: string;
  atualizado_em: string;
}

/** Usuário resumido, para o seletor de fiscal. */
export interface UsuarioResumo {
  id: number;
  nome: string;
}

export interface DiarioDetalhe extends Diario {
  itens: DiarioItem[];
  fotos: DiarioFoto[];
  ordem_servico_url?: string; // URL assinada do PDF da O.S. (quando anexada)
  criado_por_nome?: string;
  fiscal_nome?: string;
}

export interface DiarioResumo {
  id: number;
  numero: string;
  data: string;
  obra: string;
  total_fotos: number;
  assinado: boolean;
  criado_por_nome?: string;
}

// --- Catálogos padrão (extraídos da planilha original) ---

export const CATALOGO_EQUIPAMENTOS = [
  "ESCAVADEIRA ANFÍBIA", "CAM. ROLL ON ROLL OFF", "CAM. CARROCERIA", "CAM. PIPA",
  "BARCO ALUMÍNIO", "COMPACT. PERC.", "ESCA. LONG REACH", "CONJ. REBAIXAMENTO",
  "ESCAVADEIRA", "MARTELO ROMPEDOR", "GERADOR 7/25/50 Kva / TRANSFORMADOR",
  "PRISMA / SAVEIRO", "CAMINHÃO HIDROJATO", "BETONEIRA 400 L S/ CAR. ELET.",
  "ESTAÇÃO TOTAL", "CONTAINER", "SANITÁRIO QUÍMICO", "AUTOBETONEIRA", "F-4000",
  "MANGOTE AA 60 / AA46 / NÍVEL", "MOTOR VIB. A GÁS. COM B.M",
  "BOMBA MANGOTE / BOMBA ELÉTRICA", "CORTADORA DE PISO",
];

export const CATALOGO_MAO_OBRA = [
  "ENGENHEIROS", "TÉC. PLANEJAMENTO", "MOBILIZADORAS / DIGITADORA",
  "TÉCNICOS / ASSIST. TÉCNICO / AUX. TÉCNICO", "ESTAGIÁRIOS", "GER. / ENC. ADMINIST.",
  "AUX. ADM. / PESSOAL / APONT.", "ALMOX / AUX. ALMOX. / APROP.", "VIGIA / SEGURANÇA",
  "LUBRIF. / AUX. LABORATOR.", "ENC. SETOR PESSOAL", "MOTORISTAS",
  "MESTRE OBRA / ENCAR. CAMPO / C. TURMA", "TOPÓGRAFO / NIVELADOR",
  "OP. DE RETRO / ESCAVAD.", "AJUDANTES", "PEDREIROS / CARPINTEIROS",
  "OPERADOR DE AUTOBETONEIRA", "ARMADORES / CARPINT. / ANCINEIRO", "TÉC. SEGURANÇA",
  "AUX. SERVIÇOS GERAIS", "ELETRIC. / PINTOR / CALCETEIRO", "MÉDICO",
];

export const CATALOGO_EQUIPE_FISCALIZACAO = [
  "ENGENHEIROS", "TÉCNICO FISCAL", "ASSISTENTE ADMINISTRATIVO",
];
